module.exports = __webpack_public_path__ + "10_mustache_brown.adb3d551.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/10_mustache_brown.png
// module id = e3rW
// module chunks = 0